<template>
  <tbody>
    <tr>
      <td>
        <span v-if="personLocation.lastUpdateDate">
          {{ personLocation.lastUpdateDate | formatDateMMDDYYYY }}
        </span>
      </td>
      <td v-if="this.fieldEnabled('SCHOOL_YEAR')">
        {{ personLocation.schoolYear }}
      </td>
      <td>
        <div>
          <div>
            <router-link
              v-if="personLocation.districtName && personLocation.districtName !== null"
              :to="{
                name: 'PIDistrictInfoDetails',
                params: { code: personLocation.districtCode },
              }"
                class="location-name"
                style="font-weight: 700"
            >
              {{ personLocation.districtName }}
            </router-link>
            <div v-else>
              --
            </div>
            <span class="color-grey" style="padding-left: 0.25rem">
              ({{ personLocation.districtCode }})
            </span>
          </div>
          <div style="font-style: italic">
            <router-link
              v-if="personLocation.schoolName && personLocation.schoolName !== null"
              :to="{
                name: 'PISchoolInfoDetails',
                params: {
                    districtCode: personLocation.districtCode,
                    schoolCode: personLocation.schoolCode
                },
              }"
              class="location-name"
            >
              {{ personLocation.schoolName }}
            </router-link>
            <div v-else>
              --
            </div>
            <span class="color-grey" style="padding-left: 0.25rem">
              ({{ personLocation.schoolCode }})
            </span>
          </div>
        </div>
      </td>
      <td v-if="this.fieldEnabled('LOCAL_STUDENT_ID')">
        <div class="has-text-weight-bold">
          {{ personLocation.localId !== null ? personLocation.localId  : null }}
        </div>
        <div class="color-grey" v-if="this.fieldEnabled('SOURCE_CODE')">
          {{ mapSource(personLocation.sourceCode) }}
        </div>
      </td>
      <td v-if="this.fieldEnabled('ALT_STUDENT_ID')">
        <div class="has-text-weight-bold">
          {{ personLocation.altPersonId}}
        </div>
        <div class="color-grey" v-if="this.fieldEnabled('ALT_SOURCE_SIS_CODE')">
          {{ mapSource(personLocation.altSourceCode) }}
        </div>
      </td>
      <td v-if="this.currentPersonTypeCategory === 'STUDENT'
        && this.fieldEnabled('GRADE_CODE')">
        <div>
          {{ mapGrades(personLocation.gradeCode) }}
        </div>
      </td>
      <td v-if="this.currentPersonTypeCategory === 'EMPLOYEE'
        && this.fieldEnabled('HIRE_DATE')">
        <div>
          {{ personLocation.hireDate | formatDateMMDDYYYY }}
        </div>
      </td>
      <td v-if="this.currentPersonTypeCategory === 'EMPLOYEE'
        && this.fieldEnabled('JOB_CLASS_CODE')">
        <div>
          {{ mapTitle(personLocation.jobClassCode) }}
        </div>
      </td>
      <td v-if="this.currentPersonTypeCategory === 'EMPLOYEE'
        && this.fieldEnabled('SALARY')">
        <div>
          {{ personLocation.salary | formatSalary }}
        </div>
      </td>
      <td v-if="this.fieldEnabled('ACTIVE')">
        <span class="has-text-weight-bold">
          {{ activeStatus }}
        </span>
      </td>
      <td style="text-align: right">
        <a role="button" tabindex="0"
          @keyup.enter="showDetailsPanel()"
          @click="showDetailsPanel()"
        >
          <font-awesome-icon
            :icon="['far', 'angle-double-right']"
            size="2x"
            title="View Details"
          />
        </a>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';
import FieldLabels from '@/mixins/FieldLabels';

library.add(
  faAngleDoubleRight,
);
export default {
  mixins: [
    FieldLabels,
  ],
  props: {
    currentPersonTypeCategory: {
      type: String,
      default: null,
    },
    personLocation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('lookups', [
      'activeGrades',
      'activeSources',
      'activeTitles',
    ]),
    ...mapGetters('fieldLabelsModule', [
      'getFieldEnabledForPersonType',
    ]),
    activeStatus() {
      switch (this.personLocation.active) {
        case true:
          return 'Active';
        case false:
          return 'Inactive';
        default:
          return null;
      }
    },
    contextMode() {
      const identityControl = this.properties['IDENTITY_CONTROL-LIFETIME_IDS'];
      return JSON.parse(identityControl.toString().toLowerCase()) === false;
    },
  },
  methods: {
    fieldEnabled(code) {
      return this.getFieldEnabledForPersonType(code, 'ASSIGN', this.personLocation.personType);
    },
    mapGrades(gradeCode) {
      if (gradeCode) {
        const foundGrade = this.activeGrades.find(grade => grade.code === gradeCode);
        return foundGrade ? foundGrade.description : '\u00A0';
      }
      return '\u00A0';
    },

    mapSource(code) {
      if (code) {
        const foundSource = this.activeSources.find(source => source.code === code);
        return foundSource ? foundSource.description : '\u00A0';
      }
      return '\u00A0';
    },

    mapTitle(code) {
      if (code) {
        const foundTitle = this.activeTitles.find(title => title.code === code);
        return foundTitle ? foundTitle.description : '\u00A0';
      }
      return '\u00A0';
    },
    showDetailsPanel() {
      this.$emit('showDetails', this.personLocation);
    },
  },
  filters: {
    formatSalary(value) {
      if (value) {
        if (value > 0) {
          return `$${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
        }
        return '*';
      }
      return '\u00A0';
    },
  },
};
</script>

<style lang="sass" scoped>
.location-name
    font-size: 12px
.color-grey
    color: #767676
</style>
